// extracted by mini-css-extract-plugin
export default {"container":"ProfileHeader_container__xaNXl","content":"ProfileHeader_content__f0mR9","title":"ProfileHeader_title__3XSzX","back":"ProfileHeader_back__sterj"};